<div class="body" [formGroup]="formGroup">

    <mat-toolbar class="ams-toolbar">
        <button mat-icon-button>
            <mat-icon>add</mat-icon>
        </button>
        <span>Vorgang anlegen</span>
        <span class="spacer"></span>
        <span matSuffix>

            <button mat-icon-button color="warn" (click)="close()">
                <mat-icon>close</mat-icon>
            </button>

        </span>
    </mat-toolbar>

    <div class="content" [formGroup]="formGroup">

        <app-issue-form formGroupName="issue"></app-issue-form>

    </div>

    <div class="footer">

        <button [disabled]="formGroup.invalid" (click)="saveIssue()" mat-raised-button color="primary">
            Speichern
        </button>

    </div>

    <div class="overlay" *ngIf="processing$|async" @show>

        <mat-spinner diameter="50"></mat-spinner>

    </div>

</div>
